export default {"src":"/_next/static/media/about5.4aace1e7.svg","height":226,"width":260};